
<template>
  <div id="home-content" class="home">
    <TheBanner/>

<!--
    <TheFilter/>
-->
    <div class="card-list">
      <div class="row">
        
        <div class="col-md-4 col-lg-3" v-for="(item, index) in items" :key="index">
            <div class="card">
                <header>
                    {{ item.category }}
                </header>
                <span class="card-item">  
                    <span v-if="!item.isComplete">       
                        <span v-if="item.wordCount == 1">
                            {{ item.wordCount }} Word
                        </span>
                        <span v-else>
                            {{ item.wordCount }} Words
                        </span>
                    </span>
                    <span v-else>
                        {{ item.answer }}
                    </span>
                </span>
                <div>
                    {{ item.guesses.length }} of {{ item.maxGuesses }} Guesses
                </div>
            </div>   

            <div class="action-container">
                <button v-if="!pendingTransaction" @click="openModal(item.id)" class="btn btn-primary">
                    <span v-if="!item.isComplete">
                        Play Game
                    </span>
                    <span v-else>
                        Game Complete
                    </span>
                </button>
                <button v-if="pendingTransaction" disabled class="btn btn-secondary">
                    Please wait ...
                </button>
            </div>   
        </div>

        <div v-if="items.length <= 0" class="col-12">
            <div v-if="contentLoading" class="no-content">
                Loading, please wait ...
            </div>
            <div v-else class="no-content">
                No Games Available
            </div>
        </div>

      </div>
    </div>

  </div>

</template>

<script>
import { mapGetters } from "vuex";
import TheBanner from "../components/layout/TheBanner";
import TheFilter from '../components/layout/TheFilter';
import { db, auth } from "../util/firebase";
import { contractAddress, nebPay } from "../util/nebulas";

export default {
    name: "Home",
    data () {
        return {
            active: false
        }
    },
    mounted () {
    },
    computed: {
        ...mapGetters({
            items: 'getItems',
            contentLoading: 'getContentLoading',
            pendingTransaction: 'getPendingTransaction'
        })
    },
    methods: {
        openModal (id) {
            this.$store.commit('setItem', { id });
            this.$root.$emit('bv::show::modal','play-modal');        
        },
    },
    components: { TheFilter, TheBanner }
};
</script>

<style scoped lang="less">
@backgroundColor: #243447;

.card-list {
    padding: 20px 20px 0;

    .card {
        background: @backgroundColor;
        position: relative;
        color: #fff;
        height: 250px;
        padding: 20px 40px;
        border: 1px solid #000;
        border-radius: 0;
        display:flex;
        justify-content: center;
        text-align: center;
        overflow: hidden;
        text-overflow: ellipsis;

        header {
            font-size: 18px;
        }
    }

    .action-container {
        background: @backgroundColor;
        border-top: 1px solid #f7f7f7;
        margin-bottom: 10px;
        text-align: center;
        padding: 20px;

        .btn-primary {
            width: 100%;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue